import {FPNetDate, IndiceMese, ObjectFactory, UserTrace} from "@commons/types";
import {TipoRilevazionePresenze} from "@commons/mapping/LavoratorePresenzeProprietaULRecord";
import {CoppiaTimbrature} from "@commons/mapping/CoppiaTimbrature";
import {StatoWeekBaseRecord} from "@commons/mapping/StatoWeekBaseRecord";
import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {RiepilogoOrePlus} from "@commons/mapping/RiepilogoOrePlus";
import {TurnoRecord} from "@commons/mapping/TurnoRecord";
import {TurnoDistribuzioneRecord} from "@commons/mapping/TurnoDistribuzioneRecord";
import {StatoWeekPLUSRecord} from "@commons/mapping/StatoWeekPLUSRecord";
import {merge} from "lodash";
import {Calc, Coppia} from "@commons/mapping/Calc";
import {PresenzePianificazioneRecord} from "@commons/mapping/PresenzePianificazioneRecord";
import {GiustificativoRecord} from "@commons/mapping/GiustificativoRecord";
import {LavoratorePresenzeRecord} from "@commons/mapping/LavoratorePresenzeRecord";
import {DateTime} from "luxon";
import {CachePresenze} from "@commons/mapping/CachePresenze";
import {Timbrature} from "@commons/services/presenze_calcolo/sub_calcolo/Timbrature";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {PresenzeCausaleWFRecord} from "@commons/mapping/PresenzeCausaleWF";
import {GestionePlus} from "@commons/services/presenze_calcolo/GestionePlus";
import {PresenzeGiustificativo} from "@commons/mapping/PresenzeGiustificativo";
import {WeekdayNumbers} from "luxon/src/datetime";

export type CausaleGiornata = PresenzeGiustificativo | null;
export type CausaliGiornata = CausaleGiornata[];
export type GiustificativiFestivita = {

    FC: string | null,
    FS: string | null,
    SP: string | null
};

export interface RiepilogoOreStdRecord {
    hPrevMod: number;
    hPrevDiurne: number;
    hLavDiurne: number;
    hOrdDiurne: number;
    hEccDiurne: number;
    hMancanti: number;
    hTotali: number;
}

export interface StatoWeekSTDRecord extends StatoWeekBaseRecord<RiepilogoOreStdRecord> {
    index: number;
}

type PausaInTolleranzaType = {
    mancante: number,
    ritardo: number,
    valid: boolean
};

export type CausaliType = keyof (Pick<PresenzeGiornataPlusRecord, 'causaliHH' | 'causaliQI'>);

export interface PresenzeGiornataPlusRecord extends URIAndTrace {

    anno: number;
    anomalia: number;
    arrotondate: CoppiaTimbrature[];
    arrotondateLocked: boolean;
    backup?: PresenzeGiornataPlusRecord;
    causaliHH: CausaliGiornata;
    causaliQI: CausaliGiornata;
    codTurno: number;
    codTurnoPianificazione: number;
    codTurnoSviluppo: number;
    currentTurno?: TurnoRecord | null; // Solo frontend AngularJS, non gestito in React
    dtGiornata: FPNetDate;
    durataPausa: number;
    effettive: CoppiaTimbrature[];
    effettiveLocked: boolean;
    effettiveManualiFlat: (string | null)[];
    effettiveOriginali: CoppiaTimbrature[];
    effettiveFlex: CoppiaTimbrature[];
    effettiveOriginaliBackup: string[];
    idWF: number | null;

    festivo: boolean;
    giornataBloccata: boolean;
    giorno: number;
    giorno6: boolean;
    giorno7: boolean;
    idAzienda: number;
    idAziendaMaster: number;
    idAziendaTabelle: number;
    idDip: number;
    idGiorno: number;
    idGiornoPianificazione: number;
    idGiornoSviluppo: number;
    index: number;
    maskEffettive: number;
    mese: number;
    modified: boolean;
    numSettimana: number;
    pausaFlex: boolean; // Utile solo per gestione della giornata, il backend nn la valorizza e la ignora durante il salvataggio
    pausaInTolleranza: PausaInTolleranzaType | null;
    prevReadOnly: boolean;
    previste: CoppiaTimbrature[];
    previsteLocked: boolean;
    qualificaEccNC: boolean;
    selected?: boolean;
    stato: number;
    statoTrace: UserTrace | null;
    //terminali: string[];
    //week: StatoWeekPLUSRecord | Pick<StatoWeekPLUSRecord, 'totali'> | null;
    tipoRilevazione: TipoRilevazionePresenze | null;
    totali: RiepilogoOrePlus | null,
    vociPianificazione: PresenzePianificazioneRecord[]

    warning: number, // intero gestito a flag
    warningChecked: number,// intero gestito a flag
    week: StatoWeekPLUSRecord | null, // solo front-end, utile nella selezione delle giornate da giustificare

    note: string,
}

export class PresenzeGiornataPlusRecord {
    static giustificativiFestivita: {
        FC: string,
        FS: string,
        SP: string
    } = {
        FC: "",
        FS: "",
        SP: ""
    };

    static factory: ObjectFactory<PresenzeGiornataPlusRecord> = (json?) => {
        return merge<PresenzeGiornataPlusRecord, Partial<PresenzeGiornataPlusRecord> | undefined>({
            idDip: 0,
            idAziendaMaster: 0,
            idAzienda: 0,
            idAziendaTabelle: 0,
            anno: 0,
            mese: 0,
            giorno: 0,
            festivo: false,
            giorno6: false,
            giorno7: false,
            giornataBloccata: false,
            qualificaEccNC: false,
            modified: false,
            anomalia: 0,
            warning: 0,
            warningChecked: 0,
            tipoRilevazione: null,
            numSettimana: 0,
            previsteLocked: false,
            effettiveLocked: true, // NON utilizzato in FPNet REACT!
            arrotondateLocked: false,
            pausaFlex: false,
            previste: [],
            maskEffettive: 0,
            effettiveOriginali: [],
            effettiveFlex: [],
            effettiveManualiFlat: [],
            effettiveOriginaliBackup: [],
            idWF: null,
            effettive: [],
            arrotondate: [],
            //terminali: [],
            codTurnoSviluppo: 0,
            idGiornoSviluppo: 0,
            codTurnoPianificazione: 0,
            idGiornoPianificazione: 0,
            codTurno: 0,
            idGiorno: 0,
            stato: 0,
            statoTrace: null,
            dtGiornata: null,
            prevReadOnly: false,
            totali: null,
            causaliHH: [],
            causaliQI: [],
            vociPianificazione: [],
            week: null,
            durataPausa: 0,
            pausaInTolleranza: null,
            note: '',

            index: 0,

            URI: null
        }, json);
    };

    static backup = function (day: PresenzeGiornataPlusRecord) {
        // Salvo istanza di week e la ripristino dopo il backup (altrimenti il deep copy ne crea una nuova non coerente con la gestione in corso...)
        const week = day.week;
        day.backup = JSON.parse(JSON.stringify(day)) as typeof day; // provare anche lodash.clonedeep
        day.backup.week = week;
    };

    static hasPrevisto = function (day: PresenzeGiornataPlusRecord) {
        if (day.totali !== null) {
            return (RiepilogoOrePlus.getTotaleHPrev(day.totali) > 0);
        } else {
            return false;
        }
    };

    static hasEccedente = function (day: PresenzeGiornataPlusRecord) {
        if (day.totali !== null) {
            return (RiepilogoOrePlus.getTotaleHEcc(day.totali) > 0);
        } else {
            return false;
        }
    };

    static ripristinaPrevisto = function (day: PresenzeGiornataPlusRecord, distribuzione?: TurnoDistribuzioneRecord, ricalcolo: boolean = false) {
        const coppie: CoppiaTimbrature[] = [];
        if (distribuzione) {
            if (!CoppiaTimbrature.isNull(distribuzione.prima)) {
                coppie.push(distribuzione.prima!);
            }
            if (!CoppiaTimbrature.isNull(distribuzione.seconda)) {
                coppie.push(distribuzione.seconda!);
            }
            if (!CoppiaTimbrature.isNull(distribuzione.terza)) {
                coppie.push(distribuzione.terza!);
            }
            if (!CoppiaTimbrature.isNull(distribuzione.quarta)) {
                coppie.push(distribuzione.quarta!);
            }
        }
        day.previste = [];
        PresenzeGiornataPlusRecord.copy(day, day.previste, coppie, ricalcolo);
    };

    static eraseTimbrature = function (day: PresenzeGiornataPlusRecord, timbrature: CoppiaTimbrature[], ricalcolo = false) {
        for (let indE = 0; indE < timbrature.length; ++indE) {
            /* NON SERVE PIU' TRATTANDOSI SEMPRE DI PLAIN OBJECT!
            if (!angular.isFunction(timbrature[indE].getEntrata)) {
                // Normalizzo oggetto a seguito di new data entry
                timbrature[indE] = TurnoDistribuzione$CopiaTimbrature.factory(timbrature[indE]);
            }*/
            CoppiaTimbrature.setEntrata(timbrature[indE], null);
            CoppiaTimbrature.setUscita(timbrature[indE], null);
        }
        PresenzeGiornataPlusRecord.resetAnomalia(day, ricalcolo);
    };

    static copy = function (day: PresenzeGiornataPlusRecord, target: CoppiaTimbrature[], source: CoppiaTimbrature[], ricalcolo = false) {
        PresenzeGiornataPlusRecord.eraseTimbrature(day, target, ricalcolo);
        for (let indE = 0; indE < source.length; ++indE) {
            if (target.length <= indE) {
                target.push(CoppiaTimbrature.factory());
            }
            let timbratura: number | null;
            timbratura = CoppiaTimbrature.getEntrata(source[indE]);
            CoppiaTimbrature.setEntrata(target[indE], timbratura);
            timbratura = CoppiaTimbrature.getUscita(source[indE]);
            CoppiaTimbrature.setUscita(target[indE], timbratura);
        }
    };

    static defrag = function (causali: CausaliGiornata) {
        const coalesce = (value: any, valueIfNull: any) => !value ? valueIfNull : value;
        const newCausali: PresenzeGiustificativo[] = [];
        for (let indGiu = 0; indGiu < causali.length; ++indGiu) {
            if (causali[indGiu]) {
                const causale = causali[indGiu]!;
                if (PresenzeGiustificativo.isValid(causale)) {
                    let push = true;
                    for (let indNewGiu = 0; (push && indNewGiu < newCausali.length); ++indNewGiu) {
                        if (causale.idWF === 0 && newCausali[indNewGiu].codGiu === causale.codGiu) {
                            if (newCausali[indNewGiu].tipoGiu === "ORARIO") {
                                if (coalesce(newCausali[indNewGiu].valoreEvento, "") === coalesce(causale.valoreEvento, "")) {
                                    PresenzeGiustificativo.setHHCC(newCausali[indNewGiu], newCausali[indNewGiu].quantita + causale.quantita);
                                    newCausali[indNewGiu].oraInizio = undefined;
                                    newCausali[indNewGiu].oraFine = undefined;
                                    push = false;
                                }
                            } else if (newCausali[indNewGiu].tipoGiu === "EVENTO") {
                                if (coalesce(newCausali[indNewGiu].valoreEvento, "") === coalesce(causale.valoreEvento, "")) {
                                    newCausali[indNewGiu].quantita = parseFloat(newCausali[indNewGiu].quantita as any) + parseFloat(causale.quantita as any);
                                    push = false;
                                }
                            } else {
                                newCausali[indNewGiu].quantita = parseFloat(newCausali[indNewGiu].quantita as any) + parseFloat(causale.quantita as any);
                                push = false;
                            }
                        }
                    }
                    if (push) {
                        newCausali.push(causale);
                        //newCausali.push(cloneDeep(causale));
                    }
                }
            }
        }
        if (newCausali.length === 0) {
            newCausali.push(PresenzeGiustificativo.factory());
        }
        return newCausali;
    };

    static hasAnomalia = function (day: PresenzeGiornataPlusRecord) {
        return day.anomalia !== 0;
    };

    static setAnomalia = function (day: PresenzeGiornataPlusRecord, anomalia: number) {
        // N.B. imposto anomalia solo se di livello inferiore (a un valore minore corrisponde un anomalia di una gravita' maggiore)
        if (day.anomalia === -3 || anomalia < day.anomalia) {
            day.anomalia = anomalia;
        }
    };

    static resetAnomalia = function (day: PresenzeGiornataPlusRecord, ricalcolo: boolean = false) {
        day.giornataBloccata = false;
        day.anomalia = -3;
        if (!ricalcolo) {
            day.warning = 0;
            day.warningChecked = 0;
        }
    };

    static getDescrizioneAnomalia = function (day: PresenzeGiornataPlusRecord) {
        return PresenzeGiornataPlusRecord.getDescrizioneAnomaliaByNumber(day.anomalia);
    };

    static getWarnings = function (day: Pick<PresenzeGiornataPlusRecord, "warning" | "warningChecked">) {
        const warning = [];
        for (let indW = 0; indW < 16; ++indW) {
            const mask = Math.pow(2, indW);
            if (day.warning & mask) {
                if ((mask & day.warningChecked) === 0) {
                    warning.push(mask);
                }
            }
        }
        return warning;
    };

    static getDescrizioneWarning = function (warning: number) {
        let text = null;
        switch (warning) {
            case 1:
                text = "Mancata pausa";
                break;
            case 2:
                text = "Giustificativo automatico attivo";
                break;
            case 4:
                text = "Pausa maggiore del limite massimo";
                break;
            case 8:
                text = "Ore mancanti compensate con eccedenti non computabili";
                break;
            case 16:
                text = "Ore mancanti compensate con eccedenti ammessi";
                break;
            case 32:
                text = "Ore mancanti compensate con eccedenti non ammessi";
                break;
            case 64:
                text = "Presenza di ore eccedenti ammesse";
                break;
            case 128:
                text = "Presenza di ore eccedenti NON ammesse o NON computabili";
                break;
            case 256:
                text = "Tolleranza non applicabile: criteri di applicazione non rispettati!";
                break;
            case 512:
                text = "Quantità da workflow adeguata a mancante!";
                break;
            case 1024:
                text = "Giustificativo da workflow non applicabile o non conforme ad alcun status del lavoratore!";
                break;
            case 2048:
                text = "Saldo accumulo di controllo non valido!";
                break;
            case 4096:
                text = "Attenzione, verificare causale workflow!";
                break;
            case 8192:
                text = "Quantità da workflow adeguata ad eccedente!";
                break;
            case 16384:
                text = "Oltre 13 ore di lavoro nella giornata!";
                break;
            case 32768:
                text = "Rilevate timbrature da terminale virtuale e non!";
                break;
            /*case 65536:
                text = "Causale WF senza alcun aggancio verso i giustificativi!";
                break;*/
        }
        return text;
    };

    static isHired = function (day: PresenzeGiornataPlusRecord) {
        return day.totali !== null;
    };

    /**
     * Verifica se il giorno è chiuso (NON modificabile) in base al proprio <stato> in relazione al livello di chiusura dell'utente
     * Se vengono fornite sia le informazioni sul mese in gestione sia lo stato della settimana, tali informazioni saranno utilizzate per determinare la condizione di chiusura
     * @param livelloPresenzeChiusura livello di chiusura dell'utente
     * @param meseInGestione mese in gestione
     * @param lavoratore istanza di LavoratorePresenze, utile a determinare il flag <chiudiAlloSviluppo>
     * @returns {boolean} true giorno chiuso!
     */
    static isDayChiuso = function (day: PresenzeGiornataPlusRecord,
                                   livelloPresenzeChiusura?: number | null,
                                   meseInGestione?: IndiceMese | null,
                                   lavoratore?: Pick<LavoratorePresenzeRecord, 'proprieta'>) {

        let statoAlloSviluppo: number = 0;
        if (lavoratore) {
            const prop = LavoratorePresenzeRecord.getProprieta(lavoratore, DateTime.fromISO(day.dtGiornata!));
            if (prop) {
                statoAlloSviluppo = prop.chiudiAlloSviluppo ? 1 : 0;
            }
        }

        livelloPresenzeChiusura = livelloPresenzeChiusura || null;
        meseInGestione = meseInGestione || null;
        if (livelloPresenzeChiusura) {
            let statoWeek: number;
            if (meseInGestione && day.week) {
                statoWeek = (meseInGestione === day.mese) ? day.week.statoWeek : day.week.statoWeekCavallo;
            } else {
                statoWeek = livelloPresenzeChiusura; // neutralizzo controllo settimana se info non disponibile;
            }
            return (day.stato >= livelloPresenzeChiusura) || (statoWeek >= livelloPresenzeChiusura) || (statoAlloSviluppo >= livelloPresenzeChiusura);
        }
        return true;
    };

    /**
     * Restituisce true se la giornata ha giustificativi diversi da eccedente e mancante
     * @param day
     * @param giustificativi
     */
    static hasGiuDiversi = function (day: PresenzeGiornataPlusRecord, giustificativi: GiustificativoRecord[]) {
        if (day && day.causaliHH)
            for (const giu of day.causaliHH) {
                if (giu) {
                    const giustificativo = giustificativi.find(g => g.codGiu === giu.codGiu);
                    if (giustificativo)
                        if (!GiustificativoRecord.isEccedente(giustificativo) && !GiustificativoRecord.isMancante(giustificativo)) {
                            return true;
                        }
                }
            }
        return false;
    };

    static setWarning = (that: PresenzeGiornataPlusRecord, warning: number) => {
        const warningChecked = ~warning;
        that.warningChecked = that.warningChecked & warningChecked;
        that.warning |= warning;
    };

    static checkWarning = (that: PresenzeGiornataPlusRecord, warning: number) => {
        that.modified = true;
        that.warningChecked |= warning;
    };

    /**
     * Get the day of the week. 1 is Monday and 7 is Sunday
     * @param that PresenzeGiornataPlusRecord
     */
    static getDayOfWeek = (that: PresenzeGiornataPlusRecord): WeekdayNumbers => {
        return DateTime.fromISO(that.dtGiornata!).startOf("day").weekday as WeekdayNumbers;
    };

    static copyPrevisto(that: PresenzeGiornataPlusRecord) {
        that.pausaFlex = false;
        that.arrotondate = [];
        PresenzeGiornataPlusRecord.copy(that, that.arrotondate, that.previste);
    }

    static getCopiePreviste = (that: PresenzeGiornataPlusRecord): Coppia[] => {
        const coppie: Coppia[] = [];
        for (let indE = 0; indE < that.previste.length; ++indE) {
            if (CoppiaTimbrature.isValid(that.previste[indE])) {
                const coppia = new Coppia(CoppiaTimbrature.getEntrata(that.previste[indE])!, CoppiaTimbrature.getUscita(that.previste[indE])!);
                coppie.push(coppia);
            }
        }
        return coppie;
    };

    static getCopieEffettive = (that: PresenzeGiornataPlusRecord): Coppia[] => {
        const coppie: Coppia[] = [];
        //try {

        for (let indE = 0; indE < that.effettive.length; ++indE) {
            if (CoppiaTimbrature.isValid(that.effettive[indE])) {
                const coppia = new Coppia(CoppiaTimbrature.getEntrata(that.effettive[indE])!, CoppiaTimbrature.getUscita(that.effettive[indE])!);
                coppie.push(coppia);
            }
        }
        //} catch (e) {
        //console.log(e);
        //}
        return coppie;
    };

    static isEffettiveModificate = (that: PresenzeGiornataPlusRecord): boolean => {
        // console.log('that.giorno ', that.giorno)
        // console.log('CoppiaTimbrature.count(that.effettive)  ', CoppiaTimbrature.count(that.effettive))
        // console.log('CoppiaTimbrature.count(that.effettive)  ', CoppiaTimbrature.count(that.effettiveOriginali))
        // console.log('(that.maskEffettive !== 65535) ', that.maskEffettive !== 65535)
        if (that && that.effettive) {
            return CoppiaTimbrature.count(that.effettive) !== CoppiaTimbrature.count(that.effettiveOriginali) || (that.maskEffettive !== 65535);
        } else {
            return false;
        }
    };

    static getCopieArrotondate = (that: PresenzeGiornataPlusRecord): Coppia[] => {
        const coppie: Coppia[] = [];
        for (let indE = 0; indE < that.arrotondate.length; ++indE) {
            if (CoppiaTimbrature.isValid(that.arrotondate[indE])) {
                const coppia = new Coppia(CoppiaTimbrature.getEntrata(that.arrotondate[indE])!, CoppiaTimbrature.getUscita(that.arrotondate[indE])!);
                coppie.push(coppia);
            }
        }
        return coppie;
    };

    static posCausaleHH = function (that: PresenzeGiornataPlusRecord, codGiu: string) {
        if (that.causaliHH.length > 0) {
            for (let indGiu = 0; indGiu < that.causaliHH.length; ++indGiu) {
                if (that.causaliHH[indGiu] && that.causaliHH[indGiu]!.codGiu === codGiu) {
                    return indGiu;
                }
            }
        }
        return -1;
    };

    static posCausaleQI = function (that: PresenzeGiornataPlusRecord, codGiu: string) {
        if (that.causaliQI.length > 0) {
            for (let indGiu = 0; indGiu < that.causaliQI.length; ++indGiu) {
                if (that.causaliQI[indGiu] && that.causaliQI[indGiu]!.codGiu === codGiu) {
                    return indGiu;
                }
            }
        }
        return -1;
    };

    static addCausaliHH = function (that: PresenzeGiornataPlusRecord, causali: CausaliGiornata, max: number) {
        let count = 0;
        if (causali.length > 0) {
            for (let indGiu = 0; indGiu < that.causaliHH.length; ++indGiu) {
                if (that.causaliHH[indGiu] === null || !PresenzeGiustificativo.isValid(that.causaliHH[indGiu]!)) {
                    that.causaliHH[indGiu] = causali[count++];
                }
            }
            for (; that.causaliHH.length < max && count < causali.length;) {
                that.causaliHH.push(causali[count++]);
            }
        }
        return count;
    };

    static addCausaliQI = function (that: PresenzeGiornataPlusRecord, causali: CausaliGiornata, max: number) {
        let count = 0;
        if (causali.length > 0) {
            for (let indGiu = 0; indGiu < that.causaliQI.length; ++indGiu) {
                if (that.causaliQI[indGiu] === null || !PresenzeGiustificativo.isValid(that.causaliQI[indGiu]!)) {
                    that.causaliQI[indGiu] = causali[count++];
                }
            }
            for (; that.causaliQI.length < max && count < causali.length;) {
                that.causaliQI.push(causali[count++]);
            }
        }
        return count;
    };

    /**
     * rileva mancante non giustificato in centesimi
     * @param that
     * @param cache
     * @param fill se true permette di valorizzare l'eventuale giustificativo indicato dall'utente per risolvere l'anomalia
     * @param distribuzione
     */
    static getMancante = (that: PresenzeGiornataPlusRecord, cache: CachePresenze, fill: boolean, distribuzione: TurnoDistribuzioneRecord) => {
        let mancante = RiepilogoOrePlus.calcolaMancante(that.totali!, distribuzione);
        if (mancante > 0) {
            let indSetMancante = -1;
            that.totali!.hMancanti = mancante;
            //mancante /= 60;
            for (let indGiu = 0; indGiu < that.causaliHH.length; ++indGiu) {
                const causale = that.causaliHH[indGiu];
                if (causale) {
                    const giu = cache.getGiustificativo(causale.codGiu);
                    if (giu) {
                        if (GiustificativoRecord.isMancante(giu)) {
                            if (causale.quantita === null || causale.quantita === 0) {
                                indSetMancante = indGiu;
                            } else {
                                mancante -= (Math.round(causale.quantita * 60000) / 1000);
                                if (mancante < 0) {
                                    break;
                                }
                            }
                        }
                    }
                }
            }

            //mancante = Math.round(mancante * 1000) / 1000;
            if (fill && mancante > 0 && indSetMancante >= 0) {
                const causale = that.causaliHH[indSetMancante];
                PresenzeGiustificativo.setHHCC(causale!, mancante / 60);
                mancante = 0;
            }
        }

        return mancante / 60;
    };

    static getTotaleMancanteLavorato = (that: PresenzeGiornataPlusRecord, cache: CachePresenze) => {
        let mancanteLavorato = 0;
        for (let indGiu = 0; indGiu < that.causaliHH.length; ++indGiu) {
            const causale = that.causaliHH[indGiu];
            if (causale && PresenzeGiustificativo.isValid(causale)) {
                mancanteLavorato += PresenzeGiornataPlusRecord.getMancanteLavorato(cache.getGiustificativo(causale.codGiu), causale.quantita);
            }
        }
        return mancanteLavorato;
    };

    static getMancanteLavorato = function (giu: GiustificativoRecord | null, quantita: number) {
        let mancanteLavorato = 0;
        if (giu) {
            if (GiustificativoRecord.isMancante(giu) && giu.mancanteLavorato === true) {
                const minutiCausale = quantita * 60;
                mancanteLavorato += minutiCausale;
            }
        }
        return mancanteLavorato;
    };

    static adeguaArrotondate(that: PresenzeGiornataPlusRecord, monteOreCopertoDay: number) {
        if (monteOreCopertoDay > 0 && (that.totali!.hPrevDiurne + that.totali!.hPrevNotturne)) {
            const copieArr = PresenzeGiornataPlusRecord.getCopieArrotondate(that);
            if (copieArr.length > 0) {
                let indCoppia = copieArr.length - 1;
                // adeguo arrotondate a monte ore giustificativi a copertura di mancante
                while (monteOreCopertoDay > 0 && indCoppia >= 0) {
                    const coppiaTimbrature = copieArr[indCoppia];
                    const countCoppia = coppiaTimbrature.calc.getCount();
                    if (countCoppia > monteOreCopertoDay * 60) {
                        const coppiaArr = that.arrotondate[indCoppia];
                        let uscita = Calc.hhmm2hhcc(CoppiaTimbrature.getUscita(coppiaArr)); // 1830 -> 1850
                        uscita -= (monteOreCopertoDay * 100);
                        CoppiaTimbrature.setUscita(coppiaArr, Calc.hhcc2hhmm(uscita));
                        monteOreCopertoDay = 0;
                    } else {
                        monteOreCopertoDay -= (countCoppia / 60);
                        that.arrotondate[indCoppia].entrata = null;
                        that.arrotondate[indCoppia].uscita = null;
                        --indCoppia;
                    }
                }
                that.arrotondate = Timbrature.defragStrisciata(that.arrotondate);
            }

            // Se sono presenti delle timbrature effettive e ho "annullato" le arrotondate allora c'e' qualche problema!
            if (that.effettive.length > 0 && that.arrotondate.length === 0) {
                /*var validation = that.prepareValidationEffettive(day, that.proprietaGestione);
                if (validation.setPrevisto) {
                    that.setAnomalia(4);
                }*/
                PresenzeGiornataPlusRecord.setAnomalia(that, 4);
            }
        }
    }

    /**
     * Rileva giustificativo per mancate su giornata festiva
     * @param that
     * @param giustificativiFestivita
     * @param cache
     * @returns {null} null se giornata non festiva o senza giustificativi a copertura di mancante oppure PresenzeCausali:
     */
    static getMancanteFestivo = (that: PresenzeGiornataPlusRecord, cache: CachePresenze, giustificativiFestivita: GiustificativiFestivita = PresenzeGiornataPlusRecord.giustificativiFestivita): PresenzeGiustificativo | null => {
        if (that.festivo) {
            for (let indGiu = 0; indGiu < that.causaliHH.length; ++indGiu) {
                const causale = that.causaliHH[indGiu];
                if (causale && PresenzeGiustificativo.isValid(causale)) {
                    const giu = cache.getGiustificativo(causale.codGiu);
                    if (giu && GiustificativoRecord.isMancante(giu) &&
                        (causale.codGiu === giustificativiFestivita.FS) ||
                        (causale.codGiu === giustificativiFestivita.FC) ||
                        (causale.codGiu === giustificativiFestivita.SP)) {
                        if (causale.quantita !== null && causale.quantita > 0) {
                            return causale;
                        }
                    }
                }
            }
        }
        return null;
    };

    static setupGiuFS = function (aziendaCRUD: AziendaRecord) {
        PresenzeGiornataPlusRecord.giustificativiFestivita.FC = "";
        PresenzeGiornataPlusRecord.giustificativiFestivita.FS = "";
        PresenzeGiornataPlusRecord.giustificativiFestivita.SP = "";
        if (aziendaCRUD.codGiustificativoFC && aziendaCRUD.codGiustificativoFC.length > 0) {
            PresenzeGiornataPlusRecord.giustificativiFestivita.FC = aziendaCRUD.codGiustificativoFC;
        }
        if (aziendaCRUD.codGiustificativoFS && aziendaCRUD.codGiustificativoFS.length > 0) {
            PresenzeGiornataPlusRecord.giustificativiFestivita.FS = aziendaCRUD.codGiustificativoFS;
        }
        if (aziendaCRUD.santoPatrono && aziendaCRUD.santoPatrono.codGiustificativo !== null && aziendaCRUD.santoPatrono.codGiustificativo.length > 0) {
            PresenzeGiornataPlusRecord.giustificativiFestivita.SP = aziendaCRUD.santoPatrono.codGiustificativo;
        }
    };

    static getStrisciataOriginale = (that: PresenzeGiornataPlusRecord, getNullPos: boolean = false): {
        strisciata: (number | null)[],
        terminali: string[],
        nullPos: (number | null)[]
    } => {
        const strisciata: (number | null)[] = [];
        const terminali: string[] = [];
        const nullPos: (number | null)[] = [];
        const source = that.effettiveOriginali;
        let index = 0;
        for (let indE = 0; indE < source.length; ++indE) {
            if (source[indE].entrata === "") {
                CoppiaTimbrature.setEntrata(source[indE], null);
            }
            if (source[indE].uscita === "") {
                CoppiaTimbrature.setUscita(source[indE], null);
            }
            if (CoppiaTimbrature.getEntrata(source[indE]) !== null || CoppiaTimbrature.getUscita(source[indE]) !== null) {
                const maskPos = (indE * 2);
                let timb = Math.pow(2, maskPos);
                //console.log(timb);
                if (that.maskEffettive & timb) {
                    if (getNullPos) {
                        if (CoppiaTimbrature.isValidOne(source[indE])) {
                            nullPos.push(CoppiaTimbrature.getEntrata(source[indE]) === null ? index : null);
                        }
                    } else {
                        strisciata.push(CoppiaTimbrature.getEntrata(source[indE]));
                        terminali.push(source[indE].entrataTerminale);
                    }
                }
                ++index;
                timb = Math.pow(2, maskPos + 1);
                //console.log(timb);
                if (that.maskEffettive & timb) {
                    if (getNullPos) {
                        if (CoppiaTimbrature.isValidOne(source[indE])) {
                            nullPos.push(CoppiaTimbrature.getUscita(source[indE]) === null ? index : null);
                        }
                    } else {
                        strisciata.push(CoppiaTimbrature.getUscita(source[indE]));
                        terminali.push(source[indE].uscitaTerminale);
                    }
                }
                ++index;
            }
        }
        return {strisciata, terminali, nullPos};
    };

    /**
     * restituisce il mancante giustificato + il totale delle richieste di WF (solo mancante)
     * N.B. In MINUTI!
     * @param that
     * @param elencoGiustificativi
     * @param richiesteWF
     * @param idWF
     */
    static getMancanteGiustificato = (
        that: PresenzeGiornataPlusRecord,
        elencoGiustificativi: GiustificativoRecord[] | undefined,
        richiesteWF: PresenzeCausaleWFRecord[] | undefined,
        idWF: number | undefined
    ) => {
        let quantitaHHGiust = 0;
        let quantitaHHCausali = 0;

        if (that && elencoGiustificativi) {
            // ITERO SUI GIUSTIFICATIVI (ORARI E COPERTURA DI MANCANTE) DELLA GIORNATA
            const giustHHGiorno = that.causaliHH;
            giustHHGiorno.forEach((g) => {
                if (g && g.tipoGiu === "ORARIO") {
                    const giust = elencoGiustificativi.find((giu) => giu.codGiu === g.codGiu);
                    if (giust) {
                        if (giust.tipoOreGiu === "M") {
                            quantitaHHGiust += g.quantita * 60;
                        }
                    }
                }
            });

            // ITERO SULLE CAUSALI (ORARIE E COPERTURA DI MANCANTE) DELLA GIORNATA
            if (richiesteWF) {
                GestionePlus.getCausaliWFGiorno(richiesteWF, that)
                    .filter((c) => c.wf.idWF !== idWF)
                    .forEach((c) => {
                        if (c.tipoCausale === "ORE_MANCANTI"
                            && !c.wf.annullata
                            //&& c.causaleWF?.statoIniziale !== 'RIFIUTATA') {
                            && c.wf.stato !== "RIFIUTATA") {
                            quantitaHHCausali += c.quantita * 60;
                        }
                    });
            }

            return quantitaHHCausali + quantitaHHGiust;
        } else {
            //console.warn('day e gestione non definite in fn getMancanteGiustificato()');
            return 0;
        }
    };

    static isQuantitaValide = (that: PresenzeGiornataPlusRecord): boolean => {
        let quantitaValida = true;
        if (that.totali !== null) {
            for (let indCausale = 0; (quantitaValida && indCausale < that.causaliHH.length); ++indCausale) {
                if (that.causaliHH[indCausale]) {
                    quantitaValida = quantitaValida && (that.causaliHH[indCausale]!.quantitaValida || false);
                }
            }
            for (let indCausale = 0; (quantitaValida && indCausale < that.causaliQI.length); ++indCausale) {
                if (that.causaliQI[indCausale]) {
                    quantitaValida = quantitaValida && (that.causaliQI[indCausale]!.quantitaValida || false);
                }
            }
        }
        return quantitaValida;
    };

    static isQuantitaValida = (that: PresenzeGiornataPlusRecord, quantita: number, giustificativo: GiustificativoRecord | null): boolean => {
        //return true;
        // giustificativo.decimaleMin
        // giustificativo.decimaleMultipliDi
        // giustificativo.valMin
        // giustificativo.valMax
        if (giustificativo && GiustificativoRecord.hasRange(giustificativo)) {
            if (that) {
                if (GiustificativoRecord.isOrario(giustificativo)) {
                    quantita = Math.round(quantita * 60);
                }
                if (GiustificativoRecord.isRangeValid(giustificativo, quantita, RiepilogoOrePlus.getTotaleHPrev(that.totali), false)) {
                    return true;
                }
            } else {
                return true;
            }
        } else {
            return true;
        }
        return false;
    };

    static hasWFNonApplicati = (that: PresenzeGiornataPlusRecord): boolean => {
        return !!(that.warning & 1024);
    };

    /**
     * callback per il parametro replacer di JSON.stringify
     * N.B. il replacer viene usato ricorsivamente nella serializzazione dell'oggetto,
     * quindi verifico anche le proprietà di oggetti contenuti in PresenzeGiornataPlusRecord, come ad esempio CoppiaTimbrature... etc.
     * @param key
     * @param value
     */
    static replacer = (key: string, value: any): any => {
        // Filtering out properties
        switch (key) {
            // Per PresenzeGiornataPlusRecord
            case 'URI':
            case 'note':
            case 'insertTrace':
            case 'lastUpdateTrace':
            case 'deleteTrace':
            case 'festivo':
            case 'giornataBloccata':
            case 'giorno':
            case 'giorno6':
            case 'giorno7':
            case 'idAzienda':
            case 'idAziendaMaster':
            case 'idAziendaTabelle':
            case 'idDip':
            case 'idGiornoPianificazione':
            case 'anno':
            case 'mese':
            case 'week':
            case 'numSettimana':
            case 'dtGiornata':
            case 'index':
            case 'backup':
            case 'codTurnoPianificazione':
            case 'codTurnoSviluppo':
            case 'idGiornoSviluppo':
            case 'currentTurno':
            case 'selected':
            case 'statoTrace':
            case 'modified':
            case 'durataPausa': // propieta' istanziata in Javascript per uso esclusivo del client
            case 'pausaInTolleranza': // propieta' istanziata in Javascript per uso esclusivo del client
            case 'effettiveFlex': // propieta' istanziata in Javascript per uso esclusivo del client
            case 'vociPianificazione':
                return undefined;

            // Per CoppiaTimbrature
            case 'utilizzaEntrata':
            case 'utilizzaUscita':
                return undefined;
            case 'generaEntrata':
            case 'generaUscita':
                return !!value;
            case 'entrataTerminale':
            case 'uscitaTerminale':
                return value ? value : '';

            // Per CausaliGiornata (causaliHH/QI)
            case 'valoreEvento':
            case 'idAttestato':
                return value ? value : '';
            case 'quantitaHHMM':
            case 'oraInizio':
            case 'oraFine':
            case 'quantitaValida':
                return undefined;

            case 'effettiveManualiFlat':
                return value ? value : [];

            default:
                /*idGiorno
                previste
                previsteLocked
                effettive
                maskEffettive
                effettiveLocked
                effettiveManualiFlat
                effettiveOriginali
                arrotondate
                arrotondateLocked
                codTurno
                anomalia
                warning
                warningChecked
                causaliHH
                causaliQI
                pausaFlex
                prevReadOnly
                qualificaEccNC
                stato
                tipoRilevazione
                totali
                */
                return value;
        }
    }

    private static getDescrizioneAnomaliaByNumber = function (anomalia: number) {
        let text = null;
        switch (anomalia) {
            case -3:
            case -2:
                text = "E' necessario calcolare lo scorporo quantità/anomalie!";
                break;
            case -1:
                text = "Le entrate e le uscite non sono in sequenza corretta";
                break;
            case 0:
                text = "La giornata non presenta anomalie";
                break;
            case 1:
                text = "Le quantità mancanti sono maggiori delle quantità giustificate";
                break;
            case 2:
                text = "Le quantità eccedenti diurne sono maggiori delle quantità giustificate";
                break;
            case 3:
                text = "Le quantità eccedenti notturne sono maggiori delle quantità giustificate";
                break;
            case 4:
                text = "Le quantità giustificate sono maggiori delle quantità da giustificare";
                break;
            case 5:
                text = "Tabelle quantificazione e/o qualificazione eccedenti NON corrette";
                break;
            case 6: // new FPNet2020
                text = "Automatismo pausa flex non applicabile, quadrare manualmente la giornata";
                break;
            case 10: // new FPNet2020
                text = "Profilo presenze non impostato!";
                break;
            case 11: // new FPNet2020
                text = "Raggiunto il limite massimo di causali o causale scartata!";
                break;
            case 12: // new FPNet2020
                text = "Timbrature arrotondate non valide";
                break;
            case 20: // new FPNet2020
                text = "Quadratura di calcolo fallita";
                break;
            case 22: // new FPNet2020
                text = "Quadratura specifica ore prodotte fallita";
                break;
            case 23: // new FPNet2020
                text = "Indicare specifica ore prodotte";
                break;
            case 24: // new FPNet2020
                text = "E' necessario modificare il giustificativo da WF";
                break;
            case 21: // new FPNet2020
                text = PresenzeGiornataPlusRecord.getDescrizioneWarning(2048);
                break;
            case 99: // new FPNet2021
                text = "Quantità non valida di uno o più giustificativi!";
                break;
        }
        return text;
    };
}